import Vue from 'vue';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { store } from '@src/store/';

import Count from '@components/ui/count.vue';
import Button from '@components/ui/button.vue';

let PageComponent = {
  name: 'products-id',
  data() {
    return {
      template: '<p>default temp</p>',
      test: 'test',
      itemCount: null,
      sliderCurrentSlide: 1,
      mobileViewBlocks: {
        shortDetails: false,
        credit1: false,
        credit2: false,
        techDetail: false,
      },
      creditItems: {},
    };
  },
  components: {
    't-count': Count,
    't-button': Button,
  },
  computed: {
    ...mapState('params', ['breadcrumbs']),
    creditKey: function() {
      return JSON.stringify(this.creditItems);
    },
  },
  methods: {
    ...mapMutations('cart', ['addItemToCart']),
    ...mapGetters('cart', ['checkInCart', 'getCartItem']),
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data) {
      this.setTemplate(data);
    },
    toogleMobileViewBlocks: function(id) {
      this.mobileViewBlocks[id] = !this.mobileViewBlocks[id];
    },
    setCurrentSlide: function(i) {
      this.sliderCurrentSlide = i;
    },
    buttonContent: function(id) {
      return this.checkInCart()(id) ? 'В корзине' : 'В корзину';
    },
    setCreditItems: function(value, id) {
      this.$set(this.creditItems, 'credit' + id, value);
    },
    getCreditFullPrice: function(count, price) {
      if (count) {
        return `${(+count * price.trim()).toLocaleString()} руб.`;
      } else return `${(+price).toLocaleString()} руб.`;
    },
  },
  beforeRouteUpdate(to, from, next) {
    store.commit('params/setBreadcrumbs', from.path);
    if (to.params.id) {
      let url = '/api/templates/products/_id/' + to.params.id2;
      Vue.http.get(url, { params: to.query }).then((data) => {
        this.setData(data);
        next();
      });
    } else {
      next('/404');
    }
  },
  beforeRouteEnter(to, from, next) {
    store.commit(
      'params/setBreadcrumbs',
      from.path !== '/' ? from.path : '/products'
    );
    let product = document.querySelector('#product');

    if (product) {
      product.remove();
    }
    if (to.params.id) {
      let url = '/api/templates/products/_id/' + to.params.id2;
      Vue.http.get(url, { params: to.query }).then((data) => {
        next((vm) => vm.setData(data));
      });
    }
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/products/_id/_id/index.js